import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/caprock/images/close.svg'
import _imports_1 from '../../assets/down.svg'
import _imports_2 from '../../assets/caprock/images/plus.svg'
import _imports_3 from '../../assets/caprock/images/minus.svg'


const _withScopeId = n => (_pushScopeId("data-v-cc22a1ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row my-3 justify-content-center"
}
const _hoisted_2 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_3 = { class: "login-card" }
const _hoisted_4 = { class: "login-body company" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("h4", { style: {"color":"grey","font-family":"'Merriweather'"} }, " Trustees "),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-4 mb-4 font-grey" }, [
      /*#__PURE__*/_createTextVNode(" Each of the listed trustees below will receive email with the registration link to complete the caprock Individual Application Form."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" The trustees and the company will not be activated unless all the trustees have successfully completed and submitted their individual application form. ")
    ])
  ])
], -1))
const _hoisted_7 = { class: "col-md-12 col-12 table-responsive" }
const _hoisted_8 = { class: "table table-bordered w-100" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone No"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
  ])
], -1))
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_0
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_1
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"transform":"rotate(3.142rad)","height":"1.5rem"},
  src: _imports_1
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "trusteeC"
}
const _hoisted_23 = { colspan: "6" }
const _hoisted_24 = { style: {"color":"grey","font-family":"Merriweather"} }
const _hoisted_25 = { class: "form-group d-none" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "How many directors / partners are in the organisation. ", -1))
const _hoisted_27 = {
  key: 0,
  class: "table table-bordered w-100"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "No"),
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Email"),
  /*#__PURE__*/_createElementVNode("th", null, "Phone No"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, " Action ")
], -1))
const _hoisted_29 = ["id"]
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_0
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center"
}, "No managing members found", -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 1,
  class: "text-right w-100",
  style: {"color":"#6B7A99"}
}
const _hoisted_39 = { class: "row my-3 justify-content-center" }
const _hoisted_40 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_41 = { class: "login-card" }
const _hoisted_42 = { class: "login-body company" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-6 col-6" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_47 = { class: "col-md-6 col-6" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_50 = { class: "col-md-6 col-6" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_53 = {
  key: 0,
  class: "col-md-6 col-6"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-success btn-mobile btn-sm mt-3 btn-mobile font-size-15-18"
  }, " Save Member ")
], -1))
const _hoisted_55 = { class: "col-md-12 col-12 d-none" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Please select the member who will be receiving all company's communication.", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_59 = ["value"]
const _hoisted_60 = { key: 0 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center"
}, "No records found", -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = {
  class: "text-right w-100",
  style: {"color":"#6B7A99"}
}
const _hoisted_64 = { class: "row my-3 justify-content-center" }
const _hoisted_65 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_66 = { class: "login-card" }
const _hoisted_67 = { class: "login-body company" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-md-6 col-6" }
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Type", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Indvidual", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Corporate", -1))
const _hoisted_75 = {
  key: 0,
  class: "col-md-6 col-6"
}
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company Type", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian Domestic Company", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "ASIC registered Non-Australian Company", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Non-Australian Company", -1))
const _hoisted_82 = { class: "col-md-6 col-6" }
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_85 = { class: "col-md-6 col-6" }
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_88 = { class: "col-md-6 col-6" }
const _hoisted_89 = { class: "form-group" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_91 = {
  key: 1,
  class: "col-md-6 col-6"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-success btn-mobile mt-3 btn-mobile font-size-15-18"
  }, " Save Trustee ")
], -1))
const _hoisted_93 = {
  class: "modal fade delete_trustee",
  id: "delete_trustee",
  role: "dialog"
}
const _hoisted_94 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_95 = {
  class: "modal-content",
  style: {"border":"1px solid grey","border-radius":"6px"}
}
const _hoisted_96 = { class: "modal-body mb-2" }
const _hoisted_97 = { class: "row mx-1 mt-1" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Removing trustee will erase all details of this trustee.")
], -1))
const _hoisted_99 = { class: "col-md-12 text-right" }
const _hoisted_100 = {
  class: "modal fade delete_director",
  id: "delete_director",
  role: "dialog"
}
const _hoisted_101 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_102 = {
  class: "modal-content",
  style: {"border":"1px solid grey","border-radius":"6px"}
}
const _hoisted_103 = { class: "modal-body mb-2" }
const _hoisted_104 = { class: "row mx-1 mt-1" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Removing director will erase all details of this director.")
], -1))
const _hoisted_106 = { class: "col-md-12 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.trustees.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trustees, (trustee, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: trustee.trustee_id
                          }, [
                            _createElementVNode("tr", {
                              id: 'trustee_'+trustee.trustee_id
                            }, [
                              _createElementVNode("td", _hoisted_11, _toDisplayString(index+1), 1),
                              _createElementVNode("td", null, _toDisplayString(trustee['trustee_name']), 1),
                              _createElementVNode("td", null, _toDisplayString(trustee['trustee_email']), 1),
                              _createElementVNode("td", null, _toDisplayString(trustee['trustee_phone_no']), 1),
                              _createElementVNode("td", null, _toDisplayString(trustee['trustee_type']), 1),
                              _createElementVNode("td", _hoisted_12, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => {_ctx.ask_delete(trustee.trustee_id);},
                                  class: "btn-mobile btn"
                                }, _hoisted_15, 8, _hoisted_13),
                                (trustee.trustee_type=='Corporate' && trustee.trustee_id!=_ctx.show_Tdirectors)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      title: "Show Directors",
                                      type: "button",
                                      onClick: ($event: any) => {_ctx.show_directors(trustee.trustee_id);},
                                      class: "btn-mobile btn"
                                    }, _hoisted_18, 8, _hoisted_16))
                                  : _createCommentVNode("", true),
                                (trustee.trustee_type=='Corporate'  && trustee.trustee_id==_ctx.show_Tdirectors)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      title: "Hide Directors",
                                      type: "button",
                                      onClick: ($event: any) => {_ctx.hide_directors(trustee.trustee_id);},
                                      class: "btn-mobile btn"
                                    }, _hoisted_21, 8, _hoisted_19))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_10),
                            (_ctx.show_Tdirectors==trustee.trustee_id)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                                  _createElementVNode("td", _hoisted_23, [
                                    _createElementVNode("h6", _hoisted_24, " Managing Members (" + _toDisplayString(trustee['trustee_name']) + ") ", 1),
                                    _createElementVNode("div", _hoisted_25, [
                                      _hoisted_26,
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.form.no_of_directors,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.no_of_directors) = $event)),
                                        placeholder: "i.e. 2 ",
                                        class: "form-control selected-field",
                                        name: "no_of_directors",
                                        type: "text",
                                        rules: _ctx.requiredField
                                      }, null, 8, ["modelValue", "rules"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: "no_of_directors"
                                      })
                                    ]),
                                    (trustee['directors'].length)
                                      ? (_openBlock(), _createElementBlock("table", _hoisted_27, [
                                          _createElementVNode("tbody", null, [
                                            _hoisted_28,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trustee['directors'], (director, index) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: director.director_id,
                                                id: 'trustee_director_'+trustee.trustee_id
                                              }, [
                                                _createElementVNode("td", _hoisted_30, _toDisplayString(index+1), 1),
                                                _createElementVNode("td", null, _toDisplayString(director['director_name']), 1),
                                                _createElementVNode("td", null, _toDisplayString(director['director_email']), 1),
                                                _createElementVNode("td", null, _toDisplayString(director['director_phone_no']), 1),
                                                _createElementVNode("td", _hoisted_31, [
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    onClick: ($event: any) => {_ctx.ask_director_delete(director.director_id,trustee.trustee_id);},
                                                    class: "btn-mobile btn"
                                                  }, _hoisted_34, 8, _hoisted_32)
                                                ])
                                              ], 8, _hoisted_29))
                                            }), 128)),
                                            (typeof trustee['directors']=='undefined' || !trustee['directors'].length)
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_35, _hoisted_37))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (trustee['directors'].length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                          _createTextVNode(" Do you want to add another member "),
                                          _createElementVNode("img", {
                                            class: "pl-2 mr-3",
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.show_dir_form=1)),
                                            style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                                            src: _imports_2
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    ((typeof trustee['directors']=='undefined' || trustee['directors'].length==0) || (_ctx.show_dir_form==1 && trustee.trustee_id==this.active_trustee_id))
                                      ? (_openBlock(), _createBlock(_component_Form, {
                                          key: 2,
                                          ref_for: true,
                                          ref: 'director_form_'+trustee.trustee_id,
                                          id: 'director_form_'+trustee.trustee_id,
                                          method: "POST",
                                          action: "/",
                                          class: "my-1 card p-2",
                                          onSubmit: _ctx.save_director
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_39, [
                                              _createElementVNode("div", _hoisted_40, [
                                                _createElementVNode("div", _hoisted_41, [
                                                  _createElementVNode("div", _hoisted_42, [
                                                    _createElementVNode("div", _hoisted_43, [
                                                      _createElementVNode("div", _hoisted_44, [
                                                        _createElementVNode("div", _hoisted_45, [
                                                          _hoisted_46,
                                                          _createVNode(_component_Field, {
                                                            modelValue: _ctx.form.director_name,
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.director_name) = $event)),
                                                            placeholder: "i.e. Jonaten ",
                                                            class: "form-control selected-field",
                                                            name: "trustee_name",
                                                            type: "text",
                                                            rules: _ctx.requiredField
                                                          }, null, 8, ["modelValue", "rules"]),
                                                          _createVNode(_component_ErrorMessage, {
                                                            style: {"color":"#d00000"},
                                                            name: "trustee_name"
                                                          })
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_47, [
                                                        _createElementVNode("div", _hoisted_48, [
                                                          _hoisted_49,
                                                          _createVNode(_component_Field, {
                                                            modelValue: _ctx.form.director_email,
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.director_email) = $event)),
                                                            placeholder: "i.e. email@address.com  ",
                                                            class: "form-control selected-field",
                                                            name: "trustee_email",
                                                            type: "text",
                                                            rules: [_ctx.requiredField,_ctx.validateEmail]
                                                          }, null, 8, ["modelValue", "rules"]),
                                                          _createVNode(_component_ErrorMessage, {
                                                            style: {"color":"#d00000"},
                                                            name: "trustee_email"
                                                          })
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_50, [
                                                        _createElementVNode("div", _hoisted_51, [
                                                          _hoisted_52,
                                                          _createVNode(_component_Field, {
                                                            modelValue: _ctx.form.director_phone_no,
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.director_phone_no) = $event)),
                                                            placeholder: "i.e. 3539 000556  ",
                                                            class: "form-control selected-field",
                                                            name: "trustee_phone_no",
                                                            type: "text",
                                                            rules: [_ctx.requiredField,_ctx.mobileField]
                                                          }, null, 8, ["modelValue", "rules"]),
                                                          _createVNode(_component_ErrorMessage, {
                                                            style: {"color":"#d00000"},
                                                            name: "trustee_phone_no"
                                                          })
                                                        ])
                                                      ]),
                                                      (_ctx.trustees.length>0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                            _createElementVNode("img", {
                                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (this.show_dir_form=0)),
                                                              style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                                                              src: _imports_3
                                                            })
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      _hoisted_54
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["id", "onSubmit"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _hoisted_57,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.default_recipient,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.default_recipient) = $event)),
                                          class: "form-control",
                                          name: "default_recipient",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_58,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trustee['directors'], (director) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                value: director.director_id,
                                                key: director.trustee_id
                                              }, _toDisplayString(director['director_name']) + " (" + _toDisplayString(director['director_email']) + ")", 9, _hoisted_59))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "default_recipient"
                                        })
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128)),
                        (!_ctx.trustees.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_60, _hoisted_62))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createTextVNode(" Do you want to add another trustee "),
                    _createElementVNode("img", {
                      class: "pl-2 mr-3",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (this.show_form=1)),
                      style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                      src: _imports_2
                    })
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.trustees.length==0 || _ctx.show_form==1)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 1,
          ref: "trustee_form",
          id: "trustee_form",
          method: "POST",
          action: "/",
          class: "my-1 card p-2",
          onSubmit: _ctx.save_trustee
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.trustee_type,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.trustee_type) = $event)),
                            class: "form-control",
                            name: "trustee_type",
                            as: "select",
                            rules: _ctx.selectField
                          }, {
                            default: _withCtx(() => [
                              _hoisted_72,
                              _hoisted_73,
                              _hoisted_74
                            ]),
                            _: 1
                          }, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "trustee_type"
                          })
                        ])
                      ]),
                      (_ctx.form.trustee_type==2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _hoisted_77,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.form.company_type,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.company_type) = $event)),
                                class: "form-control",
                                name: "company_type",
                                as: "select",
                                rules: _ctx.selectField
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_78,
                                  _hoisted_79,
                                  _hoisted_80,
                                  _hoisted_81
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"]),
                              _createVNode(_component_ErrorMessage, {
                                style: {"color":"#d00000"},
                                name: "company_type"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.trustee_name,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.trustee_name) = $event)),
                            placeholder: "i.e. Jonaten ",
                            class: "form-control selected-field",
                            name: "trustee_name",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "trustee_name"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _hoisted_87,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.trustee_email,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.trustee_email) = $event)),
                            placeholder: "i.e. email@address.com  ",
                            class: "form-control selected-field",
                            name: "trustee_email",
                            type: "text",
                            rules: [_ctx.requiredField,_ctx.validateEmail]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "trustee_email"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.trustee_phone_no,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.trustee_phone_no) = $event)),
                            placeholder: "i.e. 3539 000556  ",
                            class: "form-control selected-field",
                            name: "trustee_phone_no",
                            type: "text",
                            rules: [_ctx.requiredField,_ctx.mobileField]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "trustee_phone_no"
                          })
                        ])
                      ]),
                      (_ctx.trustees.length>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createElementVNode("img", {
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (this.show_form=0)),
                              style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                              src: _imports_3
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_92
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _hoisted_98,
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.delete_trustee(_ctx.active_trustee_id)))
                }, "Remove"),
                _createElementVNode("button", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.closeModal('delete_trustee'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_100, [
      _createElementVNode("div", _hoisted_101, [
        _createElementVNode("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _hoisted_105,
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.delete_director(_ctx.active_director_id,_ctx.active_trustee_id)))
                }, "Remove"),
                _createElementVNode("button", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeModal('delete_director'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}